<template>
	<section id="dentalTalk_view">
		<div class="header_talk">
			<ul class="talk_profile aiR_top">
				<li class="profileImg">
					<img v-if="others.mb_icon" :src="`${SERVER_URL}/images/member/${others.mb_icon}`"
						style="max-width:100%;">
					<img v-else src="/img/common/profile_ex.png" style="max-width:100%;">
				</li>
				<li class="profileName">{{ others.mb_nick }}</li>
			</ul>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>

		<div class="content content_w">
			<div class="contIn">
				<form ref="form_talk_send" id="form_talk_send" class="aiTalk" :action="`${SERVER_URL}/api/app/talk`"
					@submit.prevent="talkjs.talkSend($event, globaljs.mb_id, globaljs.mb_boss_id, other_id, talk_content)" method="post"
					autocomplete="off">
					<div class="aiTalkWrap">
						<div class="talk_inner">
							<div v-for="(talk, index) in talks" :key="index" :class="talkClass(talk)">
								<div :class="{ 'message_box': talk.notice != 'Y' }">
									<span v-html="commonjs.replaceToBr(commonjs.stripTags(talk.content))"></span>
									<div class="time">{{ commonjs.dateFormatYMDHis(talk.createdAt) }}</div>
								</div>
							</div>
						</div>
						<div class="talk_input_box">
							<textarea v-model="talk_content" id="content" class="talk_content" @keyup.enter.prevent="talkjs.talkSend($event, globaljs.mb_id, globaljs.mb_boss_id, other_id, talk_content)"></textarea>
							<div class="talk_input_btn">
								<button type="button" class="send_btn"
									@click="talkjs.talkSend($event, globaljs.mb_id, globaljs.mb_boss_id, other_id, talk_content)">전송</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</section>

</template>

<script>
import header from '../components/layout/header.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as talkjs from '@/components/utils/talk';

const route = useRoute();
const router = useRouter();

const props = defineProps({
	other_id: {
		type: String,
		required: true
	}
});

const other_id = ref(props.other_id);

watch(
	() => props.other_id,
	(newVal) => {
		other_id.value = newVal;
	}
);

const others = ref([]); // 선택한 상대편 정보

const getOther = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('other_id', other_id.value);
	params.append('acc_type', globaljs.acc_type);
	////params.append('mb_level', globaljs.mb_level);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/other`, { params });
console.debug(response.data.result);
		if (response.data.result?.[0]) {
			others.value = response.data.result[0];

		}
	} catch (error) {
console.error('Error getOther:', error);
	}
}

const goto_url = (url) => {
	router.push(url);
}

const talks = ref([]);
const talk_content = ref();

const talkClass = (talk) => {
	let tc = "";
	if (talk.notice === 'Y') {
		tc = "talk_notice";
	} else {
		if (talk.send_mb_id === globaljs.mb_boss_id) {
			tc = "talk_me";
		} else if (talk.recv_mb_id === globaljs.mb_boss_id) {
			tc = "talk_you";
		}
	}
	return tc;
}

onMounted(async () => {
	await getOther();
	await getTalks();

	talkjs.DOMLoaded();
});


const getTalks = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('other_id', other_id.value);

	let response = await axios.get(`${SERVER_URL}/api/app/talk`, { params });
console.debug(response.data.result);
	talks.value = response.data.result;
	if (response.data.result) {
		await readTalks();
	}
}

const readTalks = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('other_id', other_id.value);

	try {
		await await axios.put(`${SERVER_URL}/api/app/talk`, params)
		.then((response) => {
console.debug(response.data.result);
		})

	} catch (error) {
console.error('Error getModels:', error);
		//return { result: 'error', msg: '메모 저장중 오류 발생' };
	}
}
</script>